import "core-js/modules/es.function.name.js";
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  theme: function theme(state) {
    return state.settings.theme;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  user: function user(state) {
    return state.user.info;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  topbarRouters: function topbarRouters(state) {
    return state.permission.topbarRouters;
  },
  defaultRoutes: function defaultRoutes(state) {
    return state.permission.defaultRoutes;
  },
  sidebarRouters: function sidebarRouters(state) {
    return state.permission.sidebarRouters;
  }
};
export default getters;